import { withTranslation } from 'react-i18next';
import { t } from "../../hooks/useAppTranslation";
/* eslint-disable no-unused-expressions */
import React from "react";
import { withRouter } from "react-router-dom";
import {getAndSaveRefreshToken} from "../../Helpers/SessionTimer";
import {getRemainingTokenTime} from "../../Helpers/utils";
import {SessionTimeoutWarning} from "../SessionTimeoutWarning/SessionTimeoutWarning";
import PopUp from "../PopUp/PopUp";
import "./SessionTimer.css";

/*
	Possibility to move timeout into redux in future.
*/

class SessionTimer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: props.date,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.props.handleRefreshSessionTime(false);
    }
  }

  render() {
    return (
      <>
        <div className='session-timer' role='timer'>
          <span className='white timer'>
            <span className='not-for-mobile'>{t("g-end-time-session", { force: true })} </span>
            {this.state.date ? this.state.date : t("g-calculating", { force: true })}
          </span>
          <button
            data-v-1c3d4cc0=''
            type='button'
            className='v-btn v-btn--icon theme--dark white--text'
            onClick={this.props.handleRefreshSessionTime}
          >
            <span className='sr-only'>{t("g-extend-time-session", { force: true })}</span>
            <div className='v-btn__content'>
              <i
                data-v-6b1eff2e=''
                aria-hidden='true'
                className='v-icon material-icons white'
              >
                timer
              </i>
            </div>
          </button>
        </div>
      </>
    );
  }
}

export default withRouter(withTranslation()(SessionTimer));